import React from 'react';

const TABS = [
  { key: 'hardpoint', label: 'Hardpoint' },
  { key: 'snd', label: 'Search & Destroy' },
  { key: 'control', label: 'Control' },
  { key: 'compare', label: 'Compare Modes' },
];

const ModeTabs = ({ activeMode, onChange }) => {
  return (
    <div className="mode-tabs-wrap" role="tablist" aria-label="Mode tabs">
      {TABS.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={activeMode === tab.key}
          className={`mode-tab ${activeMode === tab.key ? 'active' : ''}`}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default ModeTabs;

